// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Main_imgBack__jdfcK {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@keyframes Main_imgLogo__yXxAR {
    0% {
        transform: translateY(100%);
    }
    100% {
        transfrom: translateY(0);
    }
}

@keyframes Main_content__ae5Uz {
    0% {
        transform: translateY(40px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes Main_arrow__4og7d {
    0% {
        transform: translateY(-40px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

#Main_modalBackdrop__URB4d {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 10000;
}

@media only screen and (max-width: 1299px) {
    .Main_wrap__T7MEm {
        width: 100vw;
    }
    
    .Main_imgBack__jdfcK {
        position: relative;
        padding-top: 84px;
    }
    
    .Main_imgBack__jdfcK > img {
        width: 100vw;
        display: block;
    }
    
    .Main_contentContainer__8nv-d {
        font-size: 18px;
        line-height: 17px;
        color: #222222;
        font-weight: 900;
        text-align: left;
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: -12px;
        padding: 0 20px;
        width: 100vw;
    }
    
    .Main_contentContainer__8nv-d span {
        display: block;
    }
    
    .Main_arrow__4og7d {
        width: 19.5px;
        height: 32.72px;
        background-color: #DC140A;
        border-radius: 16px;
        position: relative;
        margin-top: auto;
        animation: Main_arrow__4og7d 0.6s;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        top: -28px;
    }
    
    .Main_arrow__4og7d img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 7.5px
    }
    
    .Main_content__ae5Uz {
        animation: Main_content__ae5Uz 0.6s ease-out;
        animation-fill-mode: both;
    }
    
    .Main_explainContainer__3cx-G {
        overflow-x: hidden;
        margin: 0 auto;
    }
    
    .Main_explain__G\\+hee {
        margin-top: 64.77px;
        text-align: center;
        display: flex;
        flex-direction: column;
    }
    
    .Main_explain__G\\+hee:first-child {
        padding-bottom: 55.23px;
    }
    
    #Main_explainLogo__lKLgB {
        opacity: 1;
        transition: 0.6s ease-out;
    }
    
    .Main_redDot__rHxtU {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #FF4545;
        margin-top: 8px;
        flex-shrink: 0;
    }
    
    .Main_redDot2__j2Sq1 {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #FF4545;
    }
    
    .Main_explainItem__nSfhK img {
        display: block;
        width: 150px;
        margin: 0 auto;
    }
    
    .Main_explainItem__nSfhK:nth-child(2) {
        margin: 40.77px 0 56px;
        display: flex;
        justify-content: center;
        gap: 16px;
        text-align: left;
        padding: 0 36px;
    }
    
    .Main_explainItem__nSfhK:nth-child(2) span {
        display: block;
        font-size: 16px;
        font-weight: 500;
        color: #434343;
        line-height: 26px;
        word-break: keep-all;
    }
    
    .Main_explainItem__nSfhK:nth-child(3) a {
        display: inline-block;
    }
    
    .Main_explainButton__C9x7P {
        width: 82px;
        height: 27px;
        background-color: #8BD7FF;
        border: none;
        border-radius: 24px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-weight: 500;
        font-size: 16px;
        padding: 0 16px;
        justify-content: space-between;
        margin: 0 auto;
        cursor: pointer;
    }
    
    .Main_explainButton__C9x7P > img {
        width: 6px;
    }

    .Main_explain__G\\+hee:nth-child(2) {
        background-color: #FAFAFA;
        padding: 80px 0;
        height: 735px;
    }
    .Main_explainItem2__XuzeL:nth-child(1) {
        margin-bottom: 80px;
        color: #222222;
        display: flex;
        justify-content: center;
        gap: 6px;
        align-items: center;
        font-size: 24px;
    }
    
    .Main_explainItem2__XuzeL:nth-child(2) {
        display: flex;
        gap: 31px;
        justify-content: center;
    }

    .Main_explainItem2__XuzeL:nth-child(1) > span {
        font-family: Montserrat, sans-serif;
    }
    
    .Main_spectrumContainer__Nk6YK {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 72px;
    }
    
    .Main_spectrumItem__xhpol {
        position: relative;
        height: 240px;
        transform: translateY(-24px);
    }

    .Main_spectrumItem__xhpol:nth-child(2) {
        transform: translateY(-82px);
    }

    .Main_spectrumItem__xhpol:nth-child(3) {
        height: 206px;
        overflow: hidden;
        transform: translateY(-140px);
    }

    .Main_spectrumIcon__WFoRn {
        position: absolute;
        left: 30px;
        top: 13px;
        left: 50%;
        transform: translateX(-50%);
        width: 44px;
        z-index: 1;
    }
    
    .Main_spectrumItem__xhpol img:nth-child(2) {
        height: 72px;
        position: absolute;
        transform-origin: 36px;
        transform: rotate(90deg);
        left: 0;
    }

    .Main_spectrumContentContainer__KLxJX {
        display: flex;
        flex-direction: column;
        text-align: left;
        gap: 50px;
    }
    
    .Main_spectrumContentItem__DA0-s {
        width: 217px;
        display: flex;
        flex-flow: column;
        gap: 12px;
    }
    
    .Main_contentItemTheme__ev9AD {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
        padding-left: 9px;
    }
    
    .Main_contentItemcontent__La\\+\\+n {
        font-size: 12px;
        color: #434343;
        text-indent: -8px;
        padding-left: 8px;
        line-height: 20px;
    }
    
    .Main_contentItemcontent__La\\+\\+n > span {
        display: block;
    }
    
    .Main_explain__G\\+hee:nth-child(3) {
        margin-top: 120px;
    }

    .Main_explainItem3__EsVpC:nth-child(2) {
        width: 1300px;
        margin: 120px auto 0 auto;
        display: flex;
        flex-flow: row;
        gap: 50px;
        position: relative;
    }
    
    .Main_businessItem__Fvpc9 {
        width: 400px;
        display: flex;
        flex-flow: column;
        gap: 40px;
        text-align: left;
        flex-shrink: 0;
    }
    
    .Main_businessitemLine__D7Clh {
        position: absolute;
        width: 1610px;
        height: 1px;
        background-image: linear-gradient(to right, #DC140A 10%, rgba(255, 255, 255, 0) 0%);
        background-position: top;
        background-size: 11px 1px;
        background-repeat: repeat-x;
        top: 80px;
        z-index: -10;
    }
    
    .Main_businessItemImgContainer__C3loD {
        background-color: #DC140A;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        border: none;
        position: relative;
    }
    
    .Main_businessItemImgContainer__C3loD img {
        width: 100px;
        height: 100px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    
    .Main_businessItemThemeContainer__zUNcM {
        font-size: 40px;
        color: #222222;
        font-weight: 600;
        line-height: 36px;
    }
    
    .Main_businessItemContentContainer__UU3R\\+ {
        color: #434343;
        font-size: 26px;
        line-height: 44px;
        word-break: keep-all;
    }
    
    .Main_businessItemContentContainer__UU3R\\+ span {
        display: block;
        text-indent: -18px;
        padding-left: 18px;
    }

    .Main_explainItem4__BBXUu {
        width: 240px;
        height: 65px;
        margin: 0 auto;
    }
    
    .Main_explainItem4__BBXUu > img {
        width: 150px;
    }

    .Main_explainItem4__BBXUu:nth-child(2) {
        margin-top: 21.75px;
        margin-bottom: 120px;
    }
    
    .Main_explainItem4Info__2SM\\+P {
        color: #222222;
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }
}

@media only screen and (min-width: 1300px) {
    .Main_wrap__T7MEm {
        width: 100%;
    }

    .Main_imgBack__jdfcK {
        width: 100%;
        position: relative;
    }

    .Main_imgBack__jdfcK > img {
        width: inherit;
    }

    .Main_contentContainer__8nv-d {
        font-size: 80px;
        line-height: 80px;
        color: #222222;
        font-weight: bold;
        width: 1300px;
        text-align: left;
        display: flex;
        justify-content: space-between;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -50px;
    }

    .Main_contentContainer__8nv-d span {
        width: 614px;
        display: block;
    }

    .Main_arrow__4og7d {
        width: 32px;
        height: 64px;
        background-color: #DC140A;
        border-radius: 16px;
        position: relative;
        margin-top: auto;
        animation: Main_arrow__4og7d 0.6s;
        animation-delay: 0.6s;
        animation-fill-mode: both;
        top: -100px;
    }

    .Main_arrow__4og7d img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .Main_content__ae5Uz {
        animation: Main_content__ae5Uz 0.6s ease-out;
        animation-fill-mode: both;
    }

    .Main_explainContainer__3cx-G {
        overflow-x: hidden;
        margin: 0 auto;
    }

    .Main_explain__G\\+hee {
        margin-top: 240px;
        text-align: center;
    }

    .Main_explainItem__nSfhK.Main_hover__vxbQ6 {
        height: 200px;
    }

    .Main_explainItem__nSfhK.Main_hover__vxbQ6 img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    #Main_explainLogo__lKLgB {
        opacity: 1;
    }

    .Main_redDot__rHxtU {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: #FF4545;
        margin-top: 13px;
    }

    .Main_redDot2__j2Sq1 {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background-color: #FF4545;
    }

    .Main_explainItem__nSfhK img {
        display: block;
        width: 450px;
        margin: 0 auto;
    }

    .Main_explainItem__nSfhK:nth-child(2) {
        margin: 80px 0 90px;
        display: flex;
        justify-content: center;
        gap: 36px;
        text-align: left;
    }

    .Main_explainItem__nSfhK:nth-child(2) span {
        display: block;
        width: 1180px;
        font-size: 32px;
        font-weight: 500;
        color: #434343;
        line-height: 44px;
    }

    .Main_explainItem__nSfhK:nth-child(3) a {
        display: inline-block;
    }

    .Main_explainButton__C9x7P {
        width: 147px;
        height: 48px;
        background-color: #8BD7FF;
        border: none;
        border-radius: 24px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 26px;
        padding: 0 32px;
        justify-content: space-between;
        margin: 0 auto;
        cursor: pointer;
    }

    .Main_explain__G\\+hee:nth-child(2) {
        background-color: #FAFAFA;
        padding: 200px 0;
    }
    .Main_explainItem2__XuzeL:nth-child(1) {
        margin-bottom: 80px;
        color: #222222;
        display: flex;
        justify-content: center;
        gap: 16px;
        align-items: center;
        font-size: 56px;
    }

    .Main_explainItem2__XuzeL:nth-child(1) > span {
        font-family: Montserrat, sans-serif;
    }

    .Main_spectrumContainer__Nk6YK {
        margin-bottom: 40px;
        position: relative;
        height: 160px;
        padding-left: calc((100vw - 1300px) / 2);
        display: flex;
    }

    .Main_spectrumItem__xhpol {
        position: relative;
    }

    .Main_spectrumIcon__WFoRn {
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
    }

    .Main_spectrumItem__xhpol:nth-child(n+2) {
        margin-left: -190px;
    }

    .Main_spectrumContentContainer__KLxJX {
        width: 1300px;
        margin: 0 auto;
        display: flex;
        text-align: left;
        gap: 50px;
    }

    .Main_spectrumContentItem__DA0-s {
        width: 400px;
        display: flex;
        flex-flow: column;
        gap: 40px;
    }

    .Main_contentItemTheme__ev9AD {
        font-size: 40px;
        font-weight: bold;
        color: #222222;
    }

    .Main_contentItemcontent__La\\+\\+n {
        font-size: 26px;
        color: #434343;
        text-indent: -18px;
        padding-left: 18px;
        line-height: 44px;
    }

    .Main_contentItemcontent__La\\+\\+n > span {
        display: block;
    }

    .Main_explainItem3__EsVpC:nth-child(2) {
        width: 1300px;
        margin: 120px auto 0 auto;
        display: flex;
        flex-flow: row;
        gap: 50px;
        position: relative;
    }

    .Main_businessItem__Fvpc9 {
        width: 400px;
        display: flex;
        flex-flow: column;
        gap: 40px;
        text-align: left;
        flex-shrink: 0;
    }

    .Main_businessitemLine__D7Clh {
        position: absolute;
        width: 1610px;
        height: 1px;
        background-image: linear-gradient(to right, #DC140A 10%, rgba(255, 255, 255, 0) 0%);
        background-position: top;
        background-size: 11px 1px;
        background-repeat: repeat-x;
        top: 80px;
        z-index: -10;
    }

    .Main_businessItemImgContainer__C3loD {
        background-color: #DC140A;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        border: none;
        position: relative;
    }

    .Main_businessItemImgContainer__C3loD img {
        width: 100px;
        height: 100px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .Main_businessItemThemeContainer__zUNcM {
        font-size: 40px;
        color: #222222;
        font-weight: 600;
        line-height: 36px;
    }

    .Main_businessItemContentContainer__UU3R\\+ {
        color: #434343;
        font-size: 26px;
        line-height: 44px;
        word-break: keep-all;
    }

    .Main_businessItemContentContainer__UU3R\\+ span {
        display: block;
        text-indent: -18px;
        padding-left: 18px;
    }

    .Main_explainItem4__BBXUu {
        width: 448px;
        margin: 0 auto;
    }

    /*.explainItem4 > img {*/
    /*    width: 157px;*/
    /*}*/

    .Main_explainItem4__BBXUu:nth-child(2) {
        margin-top: 80px;
        margin-bottom: 240px;
    }

    .Main_explainItem4Info__2SM\\+P {
        color: #222222;
        font-size: 32px;
        font-weight: 600;
        line-height: 40px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Main.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,aAAa;QACb,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,iCAAqB;QACrB,qBAAqB;QACrB,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC;IACJ;;IAEA;QACI,4CAAgC;QAChC,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,yBAAyB;QACzB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,8BAA8B;QAC9B,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,aAAa;IACjB;IACA;QACI,mBAAmB;QACnB,cAAc;QACd,aAAa;QACb,uBAAuB;QACvB,QAAQ;QACR,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QACtB,wBAAwB;QACxB,OAAO;IACX;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,cAAc;QACd,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,mFAAmF;QACnF,wBAAwB;QACxB,yBAAyB;QACzB,2BAA2B;QAC3B,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,iBAAiB;QACjB,aAAa;QACb,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,SAAS;QACT,2BAA2B;QAC3B,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,iCAAqB;QACrB,qBAAqB;QACrB,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;IACpC;;IAEA;QACI,4CAAgC;QAChC,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,2BAA2B;IAC/B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,eAAe;QACf,8BAA8B;QAC9B,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,cAAc;QACd,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,mCAAmC;IACvC;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,wCAAwC;QACxC,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,2BAA2B;IAC/B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;QACb,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,cAAc;QACd,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,SAAS;QACT,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,mFAAmF;QACnF,wBAAwB;QACxB,yBAAyB;QACzB,2BAA2B;QAC3B,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA,wBAAwB;IACxB,oBAAoB;IACpB,IAAI;;IAEJ;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":["@keyframes imgBack {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes imgLogo {\n    0% {\n        transform: translateY(100%);\n    }\n    100% {\n        transfrom: translateY(0);\n    }\n}\n\n@keyframes content {\n    0% {\n        transform: translateY(40px);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes arrow {\n    0% {\n        transform: translateY(-40px);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n#modalBackdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 10000;\n}\n\n@media only screen and (max-width: 1299px) {\n    .wrap {\n        width: 100vw;\n    }\n    \n    .imgBack {\n        position: relative;\n        padding-top: 84px;\n    }\n    \n    .imgBack > img {\n        width: 100vw;\n        display: block;\n    }\n    \n    .contentContainer {\n        font-size: 18px;\n        line-height: 17px;\n        color: #222222;\n        font-weight: 900;\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        position: absolute;\n        bottom: -12px;\n        padding: 0 20px;\n        width: 100vw;\n    }\n    \n    .contentContainer span {\n        display: block;\n    }\n    \n    .arrow {\n        width: 19.5px;\n        height: 32.72px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        position: relative;\n        margin-top: auto;\n        animation: arrow 0.6s;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        top: -28px;\n    }\n    \n    .arrow img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 7.5px\n    }\n    \n    .content {\n        animation: content 0.6s ease-out;\n        animation-fill-mode: both;\n    }\n    \n    .explainContainer {\n        overflow-x: hidden;\n        margin: 0 auto;\n    }\n    \n    .explain {\n        margin-top: 64.77px;\n        text-align: center;\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .explain:first-child {\n        padding-bottom: 55.23px;\n    }\n    \n    #explainLogo {\n        opacity: 1;\n        transition: 0.6s ease-out;\n    }\n    \n    .redDot {\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        background-color: #FF4545;\n        margin-top: 8px;\n        flex-shrink: 0;\n    }\n    \n    .redDot2 {\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        background-color: #FF4545;\n    }\n    \n    .explainItem img {\n        display: block;\n        width: 150px;\n        margin: 0 auto;\n    }\n    \n    .explainItem:nth-child(2) {\n        margin: 40.77px 0 56px;\n        display: flex;\n        justify-content: center;\n        gap: 16px;\n        text-align: left;\n        padding: 0 36px;\n    }\n    \n    .explainItem:nth-child(2) span {\n        display: block;\n        font-size: 16px;\n        font-weight: 500;\n        color: #434343;\n        line-height: 26px;\n        word-break: keep-all;\n    }\n    \n    .explainItem:nth-child(3) a {\n        display: inline-block;\n    }\n    \n    .explainButton {\n        width: 82px;\n        height: 27px;\n        background-color: #8BD7FF;\n        border: none;\n        border-radius: 24px;\n        display: flex;\n        align-items: center;\n        color: #FFFFFF;\n        font-weight: 500;\n        font-size: 16px;\n        padding: 0 16px;\n        justify-content: space-between;\n        margin: 0 auto;\n        cursor: pointer;\n    }\n    \n    .explainButton > img {\n        width: 6px;\n    }\n\n    .explain:nth-child(2) {\n        background-color: #FAFAFA;\n        padding: 80px 0;\n        height: 735px;\n    }\n    .explainItem2:nth-child(1) {\n        margin-bottom: 80px;\n        color: #222222;\n        display: flex;\n        justify-content: center;\n        gap: 6px;\n        align-items: center;\n        font-size: 24px;\n    }\n    \n    .explainItem2:nth-child(2) {\n        display: flex;\n        gap: 31px;\n        justify-content: center;\n    }\n\n    .explainItem2:nth-child(1) > span {\n        font-family: Montserrat, sans-serif;\n    }\n    \n    .spectrumContainer {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        width: 72px;\n    }\n    \n    .spectrumItem {\n        position: relative;\n        height: 240px;\n        transform: translateY(-24px);\n    }\n\n    .spectrumItem:nth-child(2) {\n        transform: translateY(-82px);\n    }\n\n    .spectrumItem:nth-child(3) {\n        height: 206px;\n        overflow: hidden;\n        transform: translateY(-140px);\n    }\n\n    .spectrumIcon {\n        position: absolute;\n        left: 30px;\n        top: 13px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 44px;\n        z-index: 1;\n    }\n    \n    .spectrumItem img:nth-child(2) {\n        height: 72px;\n        position: absolute;\n        transform-origin: 36px;\n        transform: rotate(90deg);\n        left: 0;\n    }\n\n    .spectrumContentContainer {\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n        gap: 50px;\n    }\n    \n    .spectrumContentItem {\n        width: 217px;\n        display: flex;\n        flex-flow: column;\n        gap: 12px;\n    }\n    \n    .contentItemTheme {\n        font-size: 16px;\n        font-weight: bold;\n        color: #222222;\n        padding-left: 9px;\n    }\n    \n    .contentItemcontent {\n        font-size: 12px;\n        color: #434343;\n        text-indent: -8px;\n        padding-left: 8px;\n        line-height: 20px;\n    }\n    \n    .contentItemcontent > span {\n        display: block;\n    }\n    \n    .explain:nth-child(3) {\n        margin-top: 120px;\n    }\n\n    .explainItem3:nth-child(2) {\n        width: 1300px;\n        margin: 120px auto 0 auto;\n        display: flex;\n        flex-flow: row;\n        gap: 50px;\n        position: relative;\n    }\n    \n    .businessItem {\n        width: 400px;\n        display: flex;\n        flex-flow: column;\n        gap: 40px;\n        text-align: left;\n        flex-shrink: 0;\n    }\n    \n    .businessitemLine {\n        position: absolute;\n        width: 1610px;\n        height: 1px;\n        background-image: linear-gradient(to right, #DC140A 10%, rgba(255, 255, 255, 0) 0%);\n        background-position: top;\n        background-size: 11px 1px;\n        background-repeat: repeat-x;\n        top: 80px;\n        z-index: -10;\n    }\n    \n    .businessItemImgContainer {\n        background-color: #DC140A;\n        width: 160px;\n        height: 160px;\n        border-radius: 50%;\n        border: none;\n        position: relative;\n    }\n    \n    .businessItemImgContainer img {\n        width: 100px;\n        height: 100px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    }\n    \n    .businessItemThemeContainer {\n        font-size: 40px;\n        color: #222222;\n        font-weight: 600;\n        line-height: 36px;\n    }\n    \n    .businessItemContentContainer {\n        color: #434343;\n        font-size: 26px;\n        line-height: 44px;\n        word-break: keep-all;\n    }\n    \n    .businessItemContentContainer span {\n        display: block;\n        text-indent: -18px;\n        padding-left: 18px;\n    }\n\n    .explainItem4 {\n        width: 240px;\n        height: 65px;\n        margin: 0 auto;\n    }\n    \n    .explainItem4 > img {\n        width: 150px;\n    }\n\n    .explainItem4:nth-child(2) {\n        margin-top: 21.75px;\n        margin-bottom: 120px;\n    }\n    \n    .explainItem4Info {\n        color: #222222;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 24px;\n    }\n}\n\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n    }\n\n    .imgBack {\n        width: 100%;\n        position: relative;\n    }\n\n    .imgBack > img {\n        width: inherit;\n    }\n\n    .contentContainer {\n        font-size: 80px;\n        line-height: 80px;\n        color: #222222;\n        font-weight: bold;\n        width: 1300px;\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        bottom: -50px;\n    }\n\n    .contentContainer span {\n        width: 614px;\n        display: block;\n    }\n\n    .arrow {\n        width: 32px;\n        height: 64px;\n        background-color: #DC140A;\n        border-radius: 16px;\n        position: relative;\n        margin-top: auto;\n        animation: arrow 0.6s;\n        animation-delay: 0.6s;\n        animation-fill-mode: both;\n        top: -100px;\n    }\n\n    .arrow img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    .content {\n        animation: content 0.6s ease-out;\n        animation-fill-mode: both;\n    }\n\n    .explainContainer {\n        overflow-x: hidden;\n        margin: 0 auto;\n    }\n\n    .explain {\n        margin-top: 240px;\n        text-align: center;\n    }\n\n    .explainItem.hover {\n        height: 200px;\n    }\n\n    .explainItem.hover img {\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n\n    #explainLogo {\n        opacity: 1;\n    }\n\n    .redDot {\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        background-color: #FF4545;\n        margin-top: 13px;\n    }\n\n    .redDot2 {\n        width: 16px;\n        height: 16px;\n        border-radius: 50%;\n        background-color: #FF4545;\n    }\n\n    .explainItem img {\n        display: block;\n        width: 450px;\n        margin: 0 auto;\n    }\n\n    .explainItem:nth-child(2) {\n        margin: 80px 0 90px;\n        display: flex;\n        justify-content: center;\n        gap: 36px;\n        text-align: left;\n    }\n\n    .explainItem:nth-child(2) span {\n        display: block;\n        width: 1180px;\n        font-size: 32px;\n        font-weight: 500;\n        color: #434343;\n        line-height: 44px;\n    }\n\n    .explainItem:nth-child(3) a {\n        display: inline-block;\n    }\n\n    .explainButton {\n        width: 147px;\n        height: 48px;\n        background-color: #8BD7FF;\n        border: none;\n        border-radius: 24px;\n        display: flex;\n        align-items: center;\n        color: #FFFFFF;\n        font-weight: bold;\n        font-size: 26px;\n        padding: 0 32px;\n        justify-content: space-between;\n        margin: 0 auto;\n        cursor: pointer;\n    }\n\n    .explain:nth-child(2) {\n        background-color: #FAFAFA;\n        padding: 200px 0;\n    }\n    .explainItem2:nth-child(1) {\n        margin-bottom: 80px;\n        color: #222222;\n        display: flex;\n        justify-content: center;\n        gap: 16px;\n        align-items: center;\n        font-size: 56px;\n    }\n\n    .explainItem2:nth-child(1) > span {\n        font-family: Montserrat, sans-serif;\n    }\n\n    .spectrumContainer {\n        margin-bottom: 40px;\n        position: relative;\n        height: 160px;\n        padding-left: calc((100vw - 1300px) / 2);\n        display: flex;\n    }\n\n    .spectrumItem {\n        position: relative;\n    }\n\n    .spectrumIcon {\n        position: absolute;\n        left: 30px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n\n    .spectrumItem:nth-child(n+2) {\n        margin-left: -190px;\n    }\n\n    .spectrumContentContainer {\n        width: 1300px;\n        margin: 0 auto;\n        display: flex;\n        text-align: left;\n        gap: 50px;\n    }\n\n    .spectrumContentItem {\n        width: 400px;\n        display: flex;\n        flex-flow: column;\n        gap: 40px;\n    }\n\n    .contentItemTheme {\n        font-size: 40px;\n        font-weight: bold;\n        color: #222222;\n    }\n\n    .contentItemcontent {\n        font-size: 26px;\n        color: #434343;\n        text-indent: -18px;\n        padding-left: 18px;\n        line-height: 44px;\n    }\n\n    .contentItemcontent > span {\n        display: block;\n    }\n\n    .explainItem3:nth-child(2) {\n        width: 1300px;\n        margin: 120px auto 0 auto;\n        display: flex;\n        flex-flow: row;\n        gap: 50px;\n        position: relative;\n    }\n\n    .businessItem {\n        width: 400px;\n        display: flex;\n        flex-flow: column;\n        gap: 40px;\n        text-align: left;\n        flex-shrink: 0;\n    }\n\n    .businessitemLine {\n        position: absolute;\n        width: 1610px;\n        height: 1px;\n        background-image: linear-gradient(to right, #DC140A 10%, rgba(255, 255, 255, 0) 0%);\n        background-position: top;\n        background-size: 11px 1px;\n        background-repeat: repeat-x;\n        top: 80px;\n        z-index: -10;\n    }\n\n    .businessItemImgContainer {\n        background-color: #DC140A;\n        width: 160px;\n        height: 160px;\n        border-radius: 50%;\n        border: none;\n        position: relative;\n    }\n\n    .businessItemImgContainer img {\n        width: 100px;\n        height: 100px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    .businessItemThemeContainer {\n        font-size: 40px;\n        color: #222222;\n        font-weight: 600;\n        line-height: 36px;\n    }\n\n    .businessItemContentContainer {\n        color: #434343;\n        font-size: 26px;\n        line-height: 44px;\n        word-break: keep-all;\n    }\n\n    .businessItemContentContainer span {\n        display: block;\n        text-indent: -18px;\n        padding-left: 18px;\n    }\n\n    .explainItem4 {\n        width: 448px;\n        margin: 0 auto;\n    }\n\n    /*.explainItem4 > img {*/\n    /*    width: 157px;*/\n    /*}*/\n\n    .explainItem4:nth-child(2) {\n        margin-top: 80px;\n        margin-bottom: 240px;\n    }\n\n    .explainItem4Info {\n        color: #222222;\n        font-size: 32px;\n        font-weight: 600;\n        line-height: 40px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `Main_modalBackdrop__URB4d`,
	"wrap": `Main_wrap__T7MEm`,
	"imgBack": `Main_imgBack__jdfcK`,
	"contentContainer": `Main_contentContainer__8nv-d`,
	"arrow": `Main_arrow__4og7d`,
	"content": `Main_content__ae5Uz`,
	"explainContainer": `Main_explainContainer__3cx-G`,
	"explain": `Main_explain__G+hee`,
	"explainLogo": `Main_explainLogo__lKLgB`,
	"redDot": `Main_redDot__rHxtU`,
	"redDot2": `Main_redDot2__j2Sq1`,
	"explainItem": `Main_explainItem__nSfhK`,
	"explainButton": `Main_explainButton__C9x7P`,
	"explainItem2": `Main_explainItem2__XuzeL`,
	"spectrumContainer": `Main_spectrumContainer__Nk6YK`,
	"spectrumItem": `Main_spectrumItem__xhpol`,
	"spectrumIcon": `Main_spectrumIcon__WFoRn`,
	"spectrumContentContainer": `Main_spectrumContentContainer__KLxJX`,
	"spectrumContentItem": `Main_spectrumContentItem__DA0-s`,
	"contentItemTheme": `Main_contentItemTheme__ev9AD`,
	"contentItemcontent": `Main_contentItemcontent__La++n`,
	"explainItem3": `Main_explainItem3__EsVpC`,
	"businessItem": `Main_businessItem__Fvpc9`,
	"businessitemLine": `Main_businessitemLine__D7Clh`,
	"businessItemImgContainer": `Main_businessItemImgContainer__C3loD`,
	"businessItemThemeContainer": `Main_businessItemThemeContainer__zUNcM`,
	"businessItemContentContainer": `Main_businessItemContentContainer__UU3R+`,
	"explainItem4": `Main_explainItem4__BBXUu`,
	"explainItem4Info": `Main_explainItem4Info__2SM+P`,
	"hover": `Main_hover__vxbQ6`,
	"imgLogo": `Main_imgLogo__yXxAR`
};
export default ___CSS_LOADER_EXPORT___;
